module.exports = __webpack_public_path__ + "img/img10.ad9828fd.png";